import { useState, useEffect, useMemo, useLayoutEffect } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useGlobalVariable } from '../../context/GlobalVariableProvider';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';

const TrustWithdrawalStatusTbl = ({
    //accounts = []
    inputs={},
    requestOnRender=false,
    type=null
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
  
    // useEffect(() => {
    //     if(requestOnRender == true){
    //         //alert("requestOnRender")
    //         handleFilter(filterParams)
    //     }
        
    // }, [requestOnRender]);



  
    useEffect(() => {
        handleFilter(filterParams)

    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];

        requestTableData(accounts,filterParams,1);

        _setInputs(filterParams);
        setAccounts(accounts);
    }

    const requestTableData = async (
        accNo: any,
        searchInputs: any,
        cPage = 1
    ) => {
        setLoading(true);
       // console.log(searchInputs);
        searchInputs.type = 2 //withdraw
        
        let result = await api.getMultiFundingHistory(
            accNo,
            searchInputs,
            cPage
        );
     // console.log("getMultiFundingHistory",result);
        if (result.funds) {
            let data = result.funds;
            // let funds = result.funds;
            // let filterFundsDatas = funds.map(data => ({
            //     f_timecreate: data.f_timecreate,
            //     trans_status : {
            //         f_transno : data.f_transno,
            //         status: data.status,
            //     },
            //     type: {
            //         mode: data.mode,
            //         type: data.type,
            //     },
            //     amount: {
            //         c_code: data.c_code,
            //         f_amount: data.f_amount,
            //     },
            //     cheque: {
            //         f_refno: data.f_refno,
            //         f_chequedate: data.f_chequedate,
            //     },
            //     bank: {
            //         b1_b_name: data.b1_b_name,
            //         b2_b_name: data.b2_b_name
            //     }
            // }));
            // console.log(funds);
            // console.log(filterFundsDatas);
            setTableData(data);

        }

        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }
        setLoading(false);
    };


    const tblColumns = useMemo(
        () => [
            // {
            //     Header: 'Date Requested',
            //     accessor: 'f_datetime', 
            //     Cell: (v: any) => {
            //         if (v.value) return moment(v.value).format('DD/MM/YYYY');
            //     }
            // },
            {
                Header: 'Requested Date',
                accessor: 'f_timecreate', 
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },
            },
            {
                Header: 'Client',
                accessor: 'a_acctno', 
            },
            {
                Header: 'User ID',
                accessor: 'f_initby', 
            },
            {
                Header: 'Currency',
                accessor: 'c_code', 
            },
            {
                Header: 'Amount Requested',
                accessor: 'f_amount', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Date Issued',
                accessor: 'dateissued', 
            },
            {
                Header: 'Requested No.',
                accessor: 'f_transno', 
            },
            {
                Header: 'Receipt No.',
                accessor: 'fw_receipt_no', 
            },   
            {
                Header: 'Amount Approved',
                accessor: 'fw_approved_amount', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Amount Approved Date',
                accessor: 'fw_approved_at', 
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },
            },
            {
                Header: 'Status',
                accessor: 'status', 
            },
            {
                Header: 'Remark',
                accessor: 'f_remark', 
            },
            {
                Header: 'Payment Type',
                accessor: 'mode', 
            },
       
       
        ],
        []
    );


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: '#B0C5F0',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                pageSize={10}
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(accounts, inputs,cPage);
                }}
                hasPagination

            />
        </>
    );
};

export default TrustWithdrawalStatusTbl;
